let nameLength = 255;

const nameRule = function (rule, value, callback) {
  if (value) {
    if (value.length > nameLength) {
      callback(new Error('文件名称超长'));
    } else {
      callback();
    }
  } else {
    callback(new Error('请输入文件名称'));
  }
  callback();
}

const rule = {
  name: [{
    type: 'string',
    required: true,
    validator: nameRule,
    trigger: 'blur'
  }],
}

export default rule;
